import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';


export const secretsKeys = {
  all: [ 'secrets' ] as const,
  list: () => [ ...secretsKeys.all, 'list' ] as const,
  detail: ( secretId: string ) => [ ...secretsKeys.all, 'detail', secretId ] as const
};

export function useSecretsQuery( opts?: { enabled?: boolean } ) {
  return useQuery( {
    queryKey: secretsKeys.list(),
    queryFn: async() => {
      return await APIGateway.secrets.secretsGet();
    },
    enabled: opts?.enabled ?? true
  } );
}

export function useSecretDetailQuery( secretId: string | undefined ) {
  return useQuery( {
    queryKey: secretsKeys.detail( secretId! ),
    queryFn: async() => {
      if ( !secretId ) throw new Error( 'Secret ID required' );
      return await APIGateway.secrets.secretGet( secretId );
    },
    enabled: !!secretId
  } );
}
